import { takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { mkEntitlement } from 'data/entitlements/entitlementsTypes';
import * as actions from 'data/entitlements/entitlementsActions';
import { getState } from 'utils/getStore';
import { getTopTierEntitlement } from 'data/entitlements/entitlementsSelectors';
import { isAcme } from 'isAcme';
import { getAuthSession } from 'utils/auth/selectors';
import { Config, ENVIRONMENT } from 'utils/webappConfig';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'entitlements',
  resourceBaseUrl: '/entitlements',
  axiosConfig: { headers: { 'qcs-dataset-id': null } },
  transformResponseToResources: (response: any) => response.data.entitlements.map((data) => mkEntitlement(data)),
  getLastSyncDate: () => null,
  ...props,
});

export function* getEntitlementsActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.getEntitlementsSuccess,
    failureAction: actions.getEntitlementsFailure,
  });
  yield takeEvery(actions.getEntitlements, getQcsSyncResources, config);
}

export function* getEntitlementsSuccessActionWatcher() {
  yield takeEvery(actions.getEntitlementsSuccess, function* getEntitlementsSuccess(_action) {
    const state = getState();
    const entitlement = getTopTierEntitlement(state);
    if (!entitlement) {
      if (isAcme) {
        const authSession = getAuthSession(state);
        window.location.href = `${Config.environments[ENVIRONMENT].pick_your_plan_url}?bearer=${authSession.accessToken}`;
      } else {
        window.location.href = 'https://www.quicken.com/non-sub/web';
      }
    }
  });
}

export default [
  getEntitlementsActionWatcher,
  getEntitlementsSuccessActionWatcher,
];
